var _mask, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoFavorites = function SvgNoFavorites(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 82 82"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "noFavorites_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 41C0 18.356 18.356 0 41 0s41 18.356 41 41-18.356 41-41 41S0 63.644 0 41"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0054A6",
    d: "M41 82v-1C18.909 81 1 63.091 1 41h-2c0 23.196 18.804 42 42 42zm41-41h-1c0 22.091-17.909 40-40 40v2c23.196 0 42-18.804 42-42zM41 0v1c22.091 0 40 17.909 40 40h2C83 17.804 64.196-1 41-1zm0 0v-1C17.804-1-1 17.804-1 41h2C1 18.909 18.909 1 41 1z",
    mask: "url(#noFavorites_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0054A6",
    fillRule: "evenodd",
    d: "M32.398 27.032c-2.846.323-5.245 1.955-6.524 4.436-.482.936-.736 1.771-.846 2.78-.054.502-.025 2.039.05 2.613.158 1.218.402 2.245.783 3.306 1.409 3.915 4.41 7.53 9.375 11.293 1.618 1.227 4.496 3.19 4.96 3.385a2.16 2.16 0 0 0 1.599.004c.468-.196 3.352-2.163 4.97-3.389 2.221-1.684 4.107-3.394 5.544-5.028 2.681-3.048 4.18-6.16 4.613-9.57.075-.589.104-2.12.05-2.614a8.05 8.05 0 0 0-2.317-4.807 8.35 8.35 0 0 0-4.453-2.323c-.957-.173-2.25-.154-3.243.047-1.838.373-3.59 1.39-5.021 2.916-.235.25-.538.6-.673.777a3 3 0 0 1-.265.323c-.01 0-.099-.108-.199-.24-.71-.946-1.85-1.99-2.833-2.592-1.14-.698-2.137-1.068-3.437-1.274-.377-.06-1.746-.087-2.133-.043",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 36.75,
    stroke: "#0054A6",
    strokeWidth: 0.5
  })));
};
export default SvgNoFavorites;